<mat-dialog-content class="add-organization-dialog-content" scrollEnd (endReached)="scrollEndReached()">
  <h3>{{ 'update_ou_lrk_identifier_dialog.title' | translate: {organizationUnitName: data.currentOu.name} }}</h3>
  @if ((loading$ | async)) {
    <mat-spinner class="center-horizontal"></mat-spinner>
  }
  @if (!(loading$ | async)) {
    <div>
      <form [formGroup]="lrkSearch" text-center>
        <mat-form-field class="organization-name" appearance="outline">
          <mat-label>{{ 'lrk_location.name.label' | translate }}</mat-label>
          <input formControlName="name" matInput (keydown.enter)="$event.preventDefault()">
        </mat-form-field>
        <div class="lrk-search-results">
          @for (organization of (lrkSearchResults$ | async); track organization) {
            <mat-card appearance="outlined" *ngVar="!!organization.used_by_organization_unit_id as inUse" [class.lrk-in-use]="inUse">
              <mat-card-header>
                <mat-icon mat-card-avatar svgIcon="doenkids-location"></mat-icon>
                <mat-card-title>{{organization.actuele_naam_oko}}</mat-card-title>
                <mat-card-subtitle>
                  <strong>{{organization.lrk_id}} </strong>
                  @if (organization.correspondentie_adres) {
                    <span>{{organization.correspondentie_adres}}, </span>
                  }
                  @if (organization.correspondentie_postcode) {
                    <span>{{organization.correspondentie_postcode}}, </span>
                  }
                  @if (organization.correspondentie_woonplaats) {
                    <span>{{organization.correspondentie_woonplaats}}</span>
                  }
                </mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>
                  @if (organization.naam_houder) {
                    <span>
                      {{ 'lrk_location.owner' | translate: {locationOwner: organization.naam_houder} }},
                    </span>
                  }
                  @if (organization.status) {
                    <span>
                      {{ 'lrk_location.status' | translate: {status: organization.status} }}
                    </span>
                  }
                </p>
                @if (inUse) {
                  <p>
                    <span class="in-use">
                      {{ 'lrk_location.already_in_use' | translate: {organizationUnitName: organization.used_by_organization_unit_name} }}
                    </span>
                  </p>
                }
              </mat-card-content>
              <mat-card-actions>
                <button [disabled]="inUse" (click)="linkLRKToOU(organization)" mat-button>
                  {{ 'generic.link' | translate | uppercase }}
                </button>
              </mat-card-actions>
            </mat-card>
          }
        </div>
      </form>
    </div>
  }
</mat-dialog-content>
